let errors: { [key: string]: string } = {}

export const getErrors = () => errors

export const setErrors = (err: {}) => {
  errors = err
}
